module.exports = __webpack_public_path__ + "img/final-pesquisa.77feaa74.png";